import { render } from "./form-persian-date.vue?vue&type=template&id=4552a9d2"
import script from "./form-persian-date.vue?vue&type=script&lang=js"
export * from "./form-persian-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__